export default __webpack_public_path__ + "static/1.2_DE-324e4423757259ae94efe141c3f21413.webp";